import { LoginMethodEnum } from '@/Domain/enum/LoginMethod.enum';
import { isActivationLanding } from '@/Domain/utils/accountActivation';

export const LAST_LOGIN_METHOD_KEY = '__qc_last_login_method';

export const rememberLoginMethod = (method: LoginMethodEnum): void => {
  try {
    localStorage.setItem(LAST_LOGIN_METHOD_KEY, method);
  } catch {
    // Browser storage may be blocked.
  }
};

// The email activation link signs the user in on the server, so it never reaches completeLogin.
export const rememberEmailLoginOnActivation = (): void => {
  if (isActivationLanding()) {
    rememberLoginMethod(LoginMethodEnum.Email);
  }
};

export const getLastLoginMethod = (): LoginMethodEnum | null => {
  try {
    const stored = localStorage.getItem(LAST_LOGIN_METHOD_KEY);
    return Object.values(LoginMethodEnum).find((method) => method === stored) ?? null;
  } catch {
    return null;
  }
};
